import { jarallax, jarallaxElement } from 'jarallax';

export default class Jarallax {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    jarallaxElement();

    jarallax(this.element, {
      type: 'element',
      speed: -3
    });

    // Synchronisation avec Lenis
    // On suppose que votre instance Lenis est accessible (souvent dans Main.js ou via window.lenis)
    if (window.lenis) {
      window.lenis.on('scroll', () => {
        // Force la mise à jour des positions de Jarallax
        jarallax(this.element, 'onScroll');
      });
    }
  }
}